import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: 'console/app-js/shared/components/switch/switch.component.html'
})
export class SwitchComponent {
  @Input() checked: Boolean = false;
  @Input() disabled: Boolean = false;
  @Output() valueUpdated = new EventEmitter();

  valueChanged = ($event: any) => {
    this.valueUpdated.emit($event);
  };
}
